{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "webmcp",
  "x-feature": true,
  "x-cli-editable": true,
  "x-access": "staff",
  "title": "WebMCP",
  "description": "Expose the website agent as a WebMCP tool on the client's pages, so AI browsers (ChatGPT, Edge, Chrome) can ask it questions directly. Off by default, enabled per client; staff-only while the standard is a W3C draft.",
  "type": "object",
  "properties": {},
  "default": {}
}
